import { styled } from '@mui/material/styles';
import Print from 'global/components/print';

export const NotifyTopHeader = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[400],
  padding: `5px 0px 5px 50px`,
}));

// TabContainer is `position: relative`, so `absolute` + `top: 72px` would sit
// in the list body instead of the page chrome. Fixed keeps the icon at the
// top-right of the viewport (below the nav), matching the pre-relative layout.
export const StyledPrint = styled(Print)({
  position: 'fixed !important',
  top: '72px !important',
  right: 10,
  zIndex: 10,
});

export const PRINT_TASK_ROW_SX = {
  '@media print': {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
};

export const PRINT_STATUS_CELL_SX = {
  '@media print': {
    minWidth: 0,
    flexShrink: 1,
    '& .MuiButton-root': {
      minWidth: 0,
      paddingLeft: '4px',
      paddingRight: '4px',
    },
    '& .MuiIcon-root': { display: 'none' },
  },
};
